// alterado - revisado

import React from 'react'

import MESSAGE from '../../business-const/Message/Message'

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardDateTimePicker,
    DateTimePicker,
    DatePicker,
} from '@material-ui/pickers'

import DateFnsUtils from '@date-io/date-fns'

import EventIcon from '@material-ui/icons/Event';

import {
    STYLE
} from '../../business-const/Style/Style'

import {
    dataAtual,
    dataValidaOuNull,
    difDatasAnos,
    stringParaData,
} from '../Date/Date'

export const MuiPickersUtilsProviderPadrao = props => {
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} {...props}>
            
        </MuiPickersUtilsProvider>
    )
}



export const KeyboardDatePickerPadrao = props => {
    return (
        <KeyboardDatePicker
            className="mt-2 mb-2 w-full"
            size="medium"
            margin="none"
            //id="mui-pickers-date"
            inputVariant="outlined"
            type="text"
            autoOk={true}
            format="dd/MM/yyyy"
            maxDate={stringParaData("31/12/2200", 'dd/mm/yyyy')}
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataInvalida : ''}
            InputProps={{
                style: STYLE(false, props.disabled).styleTextField
            }}
            InputLabelProps={{
                style: props.value || props.value === 0 ? STYLE(false, props.disabled).styleLabelTextFieldWithValue : STYLE(false, props.disabled).styleLabelTextField
            }}
            FormHelperTextProps={{
                style: STYLE(false, props.disabled).styleHelperText
            }}
            keyboardIcon={
                <EventIcon 
                    style={{
                        fontSize: "1rem"
                    }}
                />
            }
            
            {...props}
        />
    )
}

export const KeyboardDatePickerPadraoRequired = props => {
    return (
        <KeyboardDatePickerPadrao
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataInvalida : props.value ? '' : MESSAGE().campoObrigatorio}
            {...props}
        />
    )
}

export const KeyboardDatePickerPadraoTable = props => {
    return (
        <KeyboardDatePickerPadrao
            className=""    
            fullWidth

            {...props}
        />
    )
}



export const KeyboardDateTimePickerPadrao = props => {
    return (
        <KeyboardDateTimePicker
            className="mt-2 mb-2 w-full"
            size="medium"
            margin="none"
            //id="mui-pickers-date"
            inputVariant="outlined"
            type="text"
            autoOk={true}
            format="dd/MM/yyyy HH:mm"
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : ''}
            InputProps={{
                style: STYLE(false, props.disabled).styleTextField
            }}
            InputLabelProps={{
                style: props.value || props.value === 0 ? STYLE(false, props.disabled).styleLabelTextFieldWithValue : STYLE(false, props.disabled).styleLabelTextField
            }}
            FormHelperTextProps={{
                style: STYLE(false, props.disabled).styleHelperText
            }}
            keyboardIcon={
                <EventIcon 
                    style={{
                        fontSize: "1rem"
                    }}
                />
            }
            
            {...props}
        />
    )
}

export const KeyboardDateTimePickerPadraoRequired = props => {
    return (
        <KeyboardDateTimePickerPadrao
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : props.value ? '' : MESSAGE().campoObrigatorio}
            {...props}
        />
    )
}

export const KeyboardDateTimePickerPadraoTable = props => {
    return (
        <KeyboardDateTimePickerPadrao
            className=""    
            fullWidth

            {...props}
        />
    )
}



export const DateTimePickerPadrao = props => {
    return (
        <DateTimePicker
            className="mt-2 mb-2 w-full"
            size="medium"
            margin="none"
            //id="mui-pickers-date"
            inputVariant="outlined"
            type="text"
            autoOk={true}
            format="dd/MM/yyyy HH:mm"
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : ''}
            InputProps={{
                style: STYLE(false, props.disabled).styleTextField
            }}
            InputLabelProps={{
                style: props.value || props.value === 0 ? STYLE(false, props.disabled).styleLabelTextFieldWithValue : STYLE(false, props.disabled).styleLabelTextField
            }}
            FormHelperTextProps={{
                style: STYLE(false, props.disabled).styleHelperText
            }}
            {...props}
        />
    )
}

export const DateTimePickerPadraoRequired = props => {
    return (
        <DateTimePickerPadrao
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : props.value ? '' : MESSAGE().campoObrigatorio}
            {...props}
        />
    )
}

export const DateTimePickerPadraoTable = props => {
    return (
        <DateTimePickerPadrao
            className=""    
            fullWidth

            {...props}
        />
    )
}



export const DatePickerPadrao = props => {
    return (
        <DatePicker
            className="mt-2 mb-2 w-full"
            size="medium"
            margin="none"
            //id="mui-pickers-date"
            inputVariant="outlined"
            type="text"
            autoOk={true}
            format="dd/MM/yyyy"
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : ''}
            InputProps={{
                style: STYLE(false, props.disabled).styleTextField
            }}
            InputLabelProps={{
                style: props.value || props.value === 0 ? STYLE(false, props.disabled).styleLabelTextFieldWithValue : STYLE(false, props.disabled).styleLabelTextField
            }}
            FormHelperTextProps={{
                style: STYLE(false, props.disabled).styleHelperText
            }}
            {...props}
        />
    )
}

export const DatePickerPadraoRequired = props => {
    return (
        <DatePickerPadrao
            helperText={!dataValidaOuNull(props.value) ? MESSAGE().dataHoraInvalida : props.value ? '' : MESSAGE().campoObrigatorio}
            {...props}
        />
    )
}

export const DatePickerPadraoTable = props => {
    return (
        <DatePickerPadrao
            className=""    
            fullWidth

            {...props}
        />
    )
}



export const atribuiDataIdade = (setFieldValue, date, campoData, campoIdade) => {
    setFieldValue(
        campoData,
        date
    )

    let idade = difDatasAnos (date, dataAtual())
    
    setFieldValue(
        campoIdade,
        idade
    )
}